import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-link-property',
  templateUrl: './dialog-link-property.component.html',
  styleUrls: ['./dialog-link-property.component.scss'],
  standalone: false
})
export class DialogLinkPropertyComponent {
  copied = false;
  readonly entityType: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { url: string; entityType?: string },
    private dialogRef: MatDialogRef<DialogLinkPropertyComponent>
  ) {
    this.entityType = this.data.entityType === 'Project' ? 'Project' : 'Property';
    console.log('Entity Type:', this.entityType,data.url);
  }

  copyUrl() {

    navigator.clipboard.writeText(this.data.url).then(() => {
      this.copied = true;
      setTimeout(() => (this.copied = false), 2000);
    });
  }

  close() {
    this.dialogRef.close();
  }
}
